<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="800" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Add new seller
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close
    v-divider
    v-card-text.px-6.py-3
      v-form(ref="form")
        div.text-sm.font-semibold.neutral500--text.mt-4 Sold by
        v-row.mt-0
          v-col
            div.text-sm.font-semibold.neutral500--text Company Name
            v-text-field.text-sm.mt-2.round-xl(v-model="seller.sold_by" placeholder="Company name" outlined dense height="48" hide-details="auto")
          v-col
            div.text-sm.font-semibold.neutral500--text Person-in-charge name
            v-text-field.text-sm.mt-2.round-xl(v-model="seller.name" :placeholder="$t('name')" outlined dense height="48" hide-details="auto")
          v-col
            div.text-sm.font-semibold.neutral500--text Phone number
            phone-input.mt-2(v-model="seller.phone")

    v-card-actions.pb-4.pt-3.px-6
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Save" text-color="neutral100" color="neutral700" size="md" dark :loading="isLoading" @click="saveData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PhoneInput from '@/components/clinic/custom/PhoneInput.vue'

export default {
  components: { PhoneInput },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    stock: {
      default: null
    },
    product: {
      default: null
    }
  },
  data() {
    return {
      isFetching: false,
      isLoading: false,
      showAddSeller: false,
      seller: {},
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required'],
      },
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {},
  methods: {
    ...mapActions(['showMessage']),
    saveData () {
      this.isFetching = true
      let data = {
        company: this.company.id,
        field: 'medication.sold_by',
        value: this.seller.sold_by,
        enabled: true,
        extra_data: { ...this.seller }
      }
      this.$axios.post('/options', data)
        .then(() => {
          this.$emit('updated')
          this.closeDialog()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeDialog () {
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .date-field .v-input__append-inner {
    margin-top: 12px !important;
  }
}
</style>